<ng-container *ngIf="this.isDesktop; else mobileTab">
  <lib-ngx-image-zoom
    *ngIf="myThumbnail !== 'null'"
    [thumbImage]="myThumbnail"
    [fullImage]="myFullresImage"
    [magnification]="1"
    [enableScrollZoom]="true"
    [enableLens]="true"
    [lensWidth]="200"
  ></lib-ngx-image-zoom>
</ng-container>
<ng-template #mobileTab>
  <lib-ngx-image-zoom
    class="img-zoom"
    *ngIf="myThumbnail !== 'null'"
    [thumbImage]="myThumbnail"
    [fullImage]="myFullresImage"
    [magnification]="1"
    [enableScrollZoom]="true"
    [zoomMode]="'click'"
    [enableLens]="true"
    [lensHeight]="100"
    [lensWidth]="163"
  ></lib-ngx-image-zoom>
</ng-template>
